module.exports = __webpack_public_path__ + "static/opensans-semibold-webfont-0f912c694df8d33fc563069de1e08680.woff";